var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.33331C4.32634 1.33331 1.33301 4.32665 1.33301 7.99998C1.33301 11.6733 4.32634 14.6666 7.99967 14.6666C11.673 14.6666 14.6663 11.6733 14.6663 7.99998C14.6663 4.32665 11.673 1.33331 7.99967 1.33331ZM7.49967 5.33331C7.49967 5.05998 7.72634 4.83331 7.99967 4.83331C8.27301 4.83331 8.49967 5.05998 8.49967 5.33331V8.66665C8.49967 8.93998 8.27301 9.16665 7.99967 9.16665C7.72634 9.16665 7.49967 8.93998 7.49967 8.66665V5.33331ZM8.61301 10.92C8.57967 11.0066 8.53301 11.0733 8.47301 11.14C8.40634 11.2 8.33301 11.2466 8.25301 11.28C8.17301 11.3133 8.08634 11.3333 7.99967 11.3333C7.91301 11.3333 7.82634 11.3133 7.74634 11.28C7.66634 11.2466 7.59301 11.2 7.52634 11.14C7.46634 11.0733 7.41967 11.0066 7.38634 10.92C7.35301 10.84 7.33301 10.7533 7.33301 10.6666C7.33301 10.58 7.35301 10.4933 7.38634 10.4133C7.41967 10.3333 7.46634 10.26 7.52634 10.1933C7.59301 10.1333 7.66634 10.0866 7.74634 10.0533C7.90634 9.98665 8.09301 9.98665 8.25301 10.0533C8.33301 10.0866 8.40634 10.1333 8.47301 10.1933C8.53301 10.26 8.57967 10.3333 8.61301 10.4133C8.64634 10.4933 8.66634 10.58 8.66634 10.6666C8.66634 10.7533 8.64634 10.84 8.61301 10.92Z",
    fill: "#961A0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.f486255b1eb7ef81cd282b42bc5adcfd.svg";
export { ForwardRef as ReactComponent };